import HTTP from "@/_helpers/http";
import { TRANSACTIONS__API } from "@/_helpers/urls";
import { TRANSACTIONS__MUTATIONS } from "../mutation-types";
import { TRANSACTIONS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  withdrawal: [],
  dashboardwithdrawal: [],
  totalCount: 0,
  paymentMethods: [],
  isLoading: false,
  isDashboardWithdrawLoading: false,
  totalWithdrawal: 0,
  totalWithdrawalCount: 0,
  range: null,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  // [TRANSACTIONS__MUTATIONS.TRXWITHDRAWAL](state, data) {
  //   state.withdrawal = data?.data?.summaries;
  //   state.totalCount = data?.data?.summaries?.length;
  //   state.paymentMethods = data?.data?.paymentMethods;
  //   state.totalWithdrawal = data?.data?.totalWithdrawal;
  //   state.pagination = data?.data?.pagination;
  //   state.totalWithdrawalCount = data?.data?.pagination?.total;
  //   state.range = data?.data?.range || null;
  // },
  [TRANSACTIONS__MUTATIONS.TRXWITHDRAWAL](state, data) {
    state.withdrawal = data?.data?.summaries || [];
    state.paymentMethods = data?.data?.paymentMethods || [];
    state.totalWithdrawal = data?.data?.totalWithdrawal || 0;

    state.pagination = data?.data?.pagination || {
      total: 0, perPage: 10, currentPage: 1, lastPage: 1
    };

    state.totalWithdrawalCount = state.pagination.total;

    // if backend returns "dateRange"
    state.range = data?.data?.dateRange || null;

    // optional: if you still want totalCount
    state.totalCount = state.pagination.total;
  },

  [TRANSACTIONS__MUTATIONS.TRXDASHBOARDWITHDRAWAL](state, data) {
    state.dashboardwithdrawal = data?.data;
    state.totalWithdrawalCount = data?.totalCount;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_ISDASH_WITHDRAW_LOADING(state, data) {
    state.isDashboardWithdrawLoading = data;
  },
};

// Actions
const actions = {
  async [TRANSACTIONS__ACTIONS.TRXWITHDRAWAL]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        method_name,
        duration,
        status,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(method_name && { method_name }),
        ...(duration && { duration }),
        ...(status && { status }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXWITHDRAWAL}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(TRANSACTIONS__MUTATIONS.TRXWITHDRAWAL, response.data);
    } catch (error) {
      console.log(error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async [TRANSACTIONS__ACTIONS.TRXDASHBOARDWITHDRAWAL](
    { commit, state }) {
    try {
      commit("SET_ISDASH_WITHDRAW_LOADING", true);

      const response = await HTTP().get(TRANSACTIONS__API.TRXDASHBOARDWITHDRAWAL);

      commit(TRANSACTIONS__MUTATIONS.TRXDASHBOARDWITHDRAWAL, response.data);
      commit("SET_ISDASH_WITHDRAW_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](
    { state, commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().patch(
        TRANSACTIONS__API.UPDATEDEPOSIT,
        parameter
      );
      await dispatch(TRANSACTIONS__ACTIONS.TRXWITHDRAWAL);
      await dispatch(TRANSACTIONS__ACTIONS.TRXDASHBOARDWITHDRAWAL);
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
    }
  },

   async [TRANSACTIONS__ACTIONS.TRXWITHDRAWALEXCEL]({ commit }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
  
      const {
        trading_account_type_id,
        duration,
        page = 1,
        limit = -1,          // <-- IMPORTANT: for export ALL
        search = ""
      } = parameter;
  
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();
  
      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXWITHDRAWALEXCEL}${queryParams ? `?${queryParams}` : ''}`,
        { responseType: "blob" }  // important for file download
      );
  
      // Download file
      const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "trx-withdrw.xlsx";
      link.click();
  
      commit("SET_LOADING", false);
    } catch (error) {
      console.error(error);
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
